// extracted by mini-css-extract-plugin
module.exports = {"switch":"VocalFilter_switch___2PdR"};